import gql from "graphql-tag";
const getS3ignatureQuery = gql(` 
query gets3Signature($params: AWSJSON!) {
  gets3Signature(params: $params) {
  result
  }
}
`)
export default getS3ignatureQuery;
